// Mirrors hapi validationUtil.passwordRegex — keep in sync.
export const PASSWORD_RULES = [
  { key: 'length', label: 'At least 10 characters', test: p => p.length >= 10 },
  { key: 'upper', label: 'An uppercase letter', test: p => /[A-Z]/.test(p) },
  { key: 'lower', label: 'A lowercase letter', test: p => /[a-z]/.test(p) },
  { key: 'number', label: 'A number', test: p => /\d/.test(p) },
  { key: 'symbol', label: 'A symbol', test: p => /[^A-Za-z0-9]/.test(p) }
]

export const isStrongPassword = password =>
  PASSWORD_RULES.every(rule => rule.test(password || ''))
